import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs';
import { of } from 'rxjs';
import { TermsOfPaymentControllerService } from '@iota/iota-management-portal-v4-client';
import { LoadTermsOfPayment, LoadTermsOfPaymentFailure, LoadTermsOfPaymentSuccess } from '../actions/terms-of-payment.actions';

@Injectable()
export class TermsOfPaymentEffects {
    loadTermsOfPayment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadTermsOfPayment),
            mergeMap(() =>
                this.apiService.getAllTermsOfPayment().pipe(
                    map((data) => LoadTermsOfPaymentSuccess({ data })),
                    catchError((error) => of(LoadTermsOfPaymentFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private apiService: TermsOfPaymentControllerService
    ) {}
}
